import PageShell, { PageHeader, Prose } from "@/components/PageShell";
import Seo from "@/components/Seo";

const TermsPage = () => (
  <PageShell>
    <Seo title="Terms of Use — Nema TV" description="Read the terms that govern your use of Nema TV." path="/terms" />
    <PageHeader eyebrow="Legal" title="Terms of Use" subtitle="Last updated: January 2026" />
    <Prose>
      <p>
        By using Nema TV you agree to these Terms of Use. Please read them carefully.
      </p>

      <h2>Your subscription</h2>
      <p>
        Plans are billed in advance for the duration selected (1, 3, 6 or 12 months). You
        may cancel at any time; access continues until the end of the paid period.
      </p>

      <h2>Acceptable use</h2>
      <ul>
        <li>Nema TV is licensed for personal, non-commercial viewing.</li>
        <li>Do not resell, rebroadcast or record the streams for public display.</li>
        <li>Do not attempt to bypass geoblocks, DRM or account limits.</li>
      </ul>

      <h2>Availability</h2>
      <p>
        Channel line-ups may change over time and are subject to licensing. We make
        reasonable efforts to keep service reliable but do not warrant uninterrupted
        availability.
      </p>

      <h2>Termination</h2>
      <p>
        We may suspend or terminate accounts that violate these Terms or engage in fraud.
      </p>

      <h2>Contact</h2>
      <p>Questions? <a href="mailto:legal@nematv.com">legal@nematv.com</a></p>
    </Prose>
  </PageShell>
);

export default TermsPage;
